import React from "react";
import RegistrationForm from "./RegistrationForm";
import RegisterCourse from "./RegisterCourse";
import Footer from "../../../Components/Footer/Footer";
import { android_data } from "../ServicesDisplayPage/servicesData";

const Register_android = () => {
  const page_data = {
    data: android_data,
    title: "App Development",
    description: "Learn Mobile App Development with React Native & Expo",
    amount: 4000, // 👈 You can adjust per course
  };

  return (
    <>
      {/* Registration Form instead of Hero */}
      <RegistrationForm page_data={page_data} />

      {/* Service Body (course details/steps) */}
      <RegisterCourse service_steps={page_data} />

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Register_android;
